import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signOut, getCurrentAccount } from "../azure-auth";
import "../css.css";
import { FaSignOutAlt, FaUserCog } from 'react-icons/fa';
import "../uiux.css";
import Footer from './Footer';
import Header from "./Header";

const Dashboard = ({ userRole }) => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });
  const [loading, setLoading] = useState(true);

  // Load user information from Azure AD account
  useEffect(() => {
    const account = getCurrentAccount();
    if (account) {
      // Extract user info from Azure AD account
      const name = account.name || '';
      const nameParts = name.split(' ');
      setUserInfo({
        firstName: nameParts[0] || '',
        lastName: nameParts.slice(1).join(' ') || '',
        email: account.username || account.homeAccountId || ''
      });
    }
    setLoading(false);
  }, []);

  // Define all available agents
  const allAgents = [
    {
      id: "G",
      name: "Ask IT",
      iconSrc: "/it_bot.png",
      path: "/ask-IT",
      description: "Ask IT assistant AI support for IT Services"
    },
    
    {
      id: "B",
      name: "ASK HR",
      iconSrc: "/innospace_bot.png",
      path: "/askhr",
      description: "Assistant for HR-related queries and support"
    },
    {
      id: "H",
      name: "Ask Admin",
      iconSrc: "/admin_bot.png",
      path: "/ask-admin",
      description: "Ask Admin Get help with administrative tasks"
    },
    {
      id: "W",
      name: "Ask Finance",
      iconSrc: "/finance_bot.png",
      path: "/ask-finance-copilot",
      description: "Ask Finance Copilot for finance-related queries and support",
    },
    {
      id: "E",
      name: "Ask Enterprise",
      iconSrc: "/internship_bot.png",
      path: "/ask-enterprise",
      description: "Assistant for enterprise-related queries and support",
    },
    {
      id: "M",
      name: "WorkMate AI",
      iconSrc: "/finance_bot.png",
      path: "/workmate-ai",
      description: "WorkMate AI assistant for workplace collaboration and support",
    },
    {
      id: "D",
      name: "SLT Embryo Agent",
      iconSrc: "/embryo_bot.png",
      path: "/embryo",
      description: "Embryo project management assistant",
      comingSoon: true
    },
    
    // {
    //   id: "F",
    //   name: "Ask Finance",
    //   iconSrc: "/finance_bot.png",
    //   path: "/ask-finance",
    //   description: "Ask Finance assistant for finance-related questions"
    // },
    {
      id: "A",
      name: "Aisle Agent",
      iconSrc: "/bot.png",
      path: "/test-aisle-web",
      description: "AI assistant for web testing and aisle management",
      comingSoon: true
    },
    {
      id: "C",
      name: "SLT Digital Lab",
      iconSrc: "/digital_bot.png",
      path: "/digital-lab",
      description: "Digital lab internship Q&A assistant",
      comingSoon: true
    },
    
   
  ];

  const getAccessibleAgents = () => {
    // All authenticated users can access all agents
    if (userRole) {
      return allAgents;
    }
    return allAgents;
  };

  const accessibleAgents = getAccessibleAgents();

  const handleAgentClick = (agent) => {
    if (agent.comingSoon) {
      alert("This agent is coming soon! Stay tuned for updates.");
    } else {
      navigate(agent.path);
    }
  };

  const handleAdminDashboard = () => {
    navigate("/admin-dashboard");
  };

  const handleLogout = async () => {
    try {
      await signOut();
      // Force navigation to login page after logout
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      // Even if logout fails, redirect to login
      navigate("/login", { replace: true });
    }
  };

  const getRoleDisplayName = () => {
    switch(userRole) {
      case "admin":
        return "Administrator";
      case "user":
        return "Standard User";
      case "F":
        return "Full Access User";
      case "A":
        return "Test Aisle Web User";
      case "B":
        return "Ask HR User";
      case "C":
        return "Digital Lab User";
      case "D":
        return "Embryo User";
      case "E":
        return "Ask Enterprise";
      case "F":
        return "ask finance";
      case "G":
        return "ask IT";
      case "H":
        return "ask admin";
      case  "W":
        return "WorkMate AI";
      case "M":
        return "ask finance copilot";
      default:
        return "User";
    }
  };

  console.log('Dashboard userRole prop:', userRole);
  console.log('Role type:', typeof userRole);

  const getWelcomeText = () => {
    const firstName = userInfo.firstName;
    const lastName = userInfo.lastName;

    if (firstName && lastName) {
      return `Welcome, ${firstName} ${lastName}`;
    } else if (firstName) {
      return `Welcome, ${firstName}`;
    } else if (lastName) {
      return `Welcome, ${lastName}`;
    } else {
      return `Welcome, ${getRoleDisplayName()}`;
    }
  };

  return (
    <>
      <Header/>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        marginBottom: '30px',
        flexWrap: 'wrap',
        gap: '15px'
      }}>
        <div className="container">
          {/* Header with user info and action buttons */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '30px',
            flexWrap: 'wrap',
            gap: '15px'
          }}>
            <div className="title">
              <h1 style={{ margin: 0, fontSize: '32px' }}>Agent Dashboard</h1>
              <p style={{
                margin: '5px 0 0 0',
                color: '#ccc',
                fontSize: '16px'
              }}>
                {getWelcomeText()}
              </p>
            </div>

            <div style={{
              display: 'flex',
              gap: '10px',
              flexWrap: 'wrap'
            }}>
              {/* Admin Dashboard Button - Only show for admin users */}
              {userRole === "admin" && (
                <button
                  onClick={handleAdminDashboard}
                  style={{
                    background: 'linear-gradient(135deg, #6c5ce7, #a29bfe)',
                    color: 'white',
                    marginTop:'30px',
                    padding: '10px 20px',
                    fontSize: '14px',
                    fontWeight: '600',
                    border: 'none',
                    borderRadius: '25px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.background = 'linear-gradient(135deg, #5f3dc4, #9775fa)';
                    e.target.style.boxShadow = '0 6px 18px rgba(0, 0, 0, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.background = 'linear-gradient(135deg, #6c5ce7, #a29bfe)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
                  }}
                >
                   <FaUserCog style={{ fontSize: '16px' }} />
                  Admin Dashboard
                </button>
              )}

<button className="Btn" onClick={handleLogout}>
              <div className="sign">
                <svg viewBox="0 0 512 512">
                  <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path>
                </svg>
              </div>
              <div className="text">Logout</div>
            </button>
          </div>
        </div>

          {/* Agents Grid */}
          {accessibleAgents.length > 0 ? (
            <div className="agents-grid">
              {accessibleAgents.map((agent) => (
                <AgentCard
                  key={agent.id}
                  agent={agent}
                  agentName={agent.name}
                  iconSrc={agent.iconSrc}
                  description={agent.description}
                  onClick={() => handleAgentClick(agent)}
                />
              ))}
            </div>
          ) : (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '12px',
              color: '#fff'
            }}>
              <h3>No Agents Available</h3>
              <p>You don't have access to any agents. Please contact your administrator.</p>
            </div>
          )}

          {/* User Info */}
          <div style={{
            marginTop: '40px',
            padding: '20px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            <p style={{
              color: '#ccc',
              fontSize: '14px',
              margin: 0,
              lineHeight: '1.5'
            }}>
              Your Role: <strong>{getRoleDisplayName()}</strong> |
              Access Level: <strong>{accessibleAgents.length} Agent{accessibleAgents.length !== 1 ? 's' : ''}</strong>
              {userInfo.email && (
                <>
                  {' | '}
                  Email: <strong>{userInfo.email}</strong>
                </>
              )}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const AgentCard = ({ agent, agentName, iconSrc, description, onClick }) => (
  <div
    className="agent-card"
    onClick={onClick}
    style={{
      position: 'relative',
      opacity: agent?.comingSoon ? 0.7 : 1
    }}
  >
    <img
      src={iconSrc}
      alt={`${agentName} Icon`}
      className="agent-icon"
    />
    <div className="agent-name">{agentName}</div>
    <p style={{
      fontSize: '13px',
      color: '#ccc',
      margin: '10px 0 0 0',
      lineHeight: '1.4'
    }}>
      {description}
    </p>

    {agent?.comingSoon && (
      <div style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        background: 'rgba(255, 165, 0, 0.9)',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '12px',
        fontSize: '10px',
        fontWeight: '600'
      }}>
        Coming Soon
      </div>
    )}
  </div>
);

export default Dashboard;